<template>
  <div class="bottomRecordNum">
    <!-- <p> 沈阳格众网络科技股份有限公司</p> -->
    <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">滇ICP备2022002028号-1</a>
    <!-- <a class="policeHref" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202000652">
      <img class="police" src="../assets/imgs/police.png"/>
      <span>辽公网安备21010202001003号</span>
    </a> -->
  </div>
</template>

<script>

  export default {
    data() {
      return {
        
      }
    },
    created() {
      
    },
    mounted() {
    },
    computed: {
      
    },
    watch: {

    },
    methods: {
      
    }
  }
</script>

<style lang="scss">
  .bottomRecordNum{
    text-align: center;
    padding: 10px 0;
    background-color: #fff;
    color: #000;
  }
  .bottomRecordNum a{
    color: #000;
  }
  .policeHref{
    margin-left: 20px;
  }
  .police{
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
</style>